import { render } from "./RenderNumber.vue?vue&type=template&id=74f22802"
import script from "./RenderNumber.vue?vue&type=script&lang=js"
export * from "./RenderNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__